import { useNavigate } from "react-router-dom";

function CallbackPage() {
    const called = useRef(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (called.current) return;
        
        const params = new URLSearchParams(window.location.search);
        const state = params.get('state');
        const code = params.get('code');
        const error = params.get('error');

        if (error) {
            alert("Access denied by the user");
            navigate('/spotify-connect');
            return;
        }

        if (state) {
            called.current = true;
            const apiUrl = `https://api.lovelifyapp.org/auth/callback?code=${code}&state=${state}`;

            fetch(apiUrl, {
                method: "POST",
                headers: {}
            })
            .then(res => {
                if (!res.ok) throw new Error("Error in response");
                navigate('/app');
                return;
            })
            .catch(err => console.error(err));
        }
    }, [navigate]);

    return <h2>Conectando con Spotify, espera un momento... </h2>
}

export default CallbackPage;